<template>
  <!-- 值 
      ! 如果需要定制下划线可以使用border-bottom样式设置
     -->
  <!-- :style="{ textDecoration: underline ? 'underline' : undefined }" -->
  <!-- :style="{ borderBottom: underline ? '1px solid' : 'none' }" -->
  <span
    class="render-item_val"
    :style="{
      borderBottom: underline ? '1px solid #5c5c5c' : 'none',
      paddingBottom: '2px',
      color: currentRenderColor,
    }"
    :class="{ italic, strong }"
  >
    <!-- 左下划线 -->
    <template v-for="i in leftFilling || []">&ensp;</template>
    <span @click="onPlay(content)" class="videoStr">
      <template v-for="i in content || []">
        <template v-if="i === ' '">&ensp;</template>
        <template v-else>{{ i }}</template>
      </template>
    </span>
    <template v-for="i in rightFilling || []">&ensp;</template>
    <a id="file" name="file"  download="filename" hidden href=""></a>
    <span
      style="color: transparent; display: contents; word-break: break-all"
      >{{ seat }}</span
    >
    <el-dialog
      title="视频播放"
      :visible.sync="dialogVisible"
      append-to-body
      width="1200px"
    >
      <div
        v-if="dialogVisible"
        class="videoBox"
        style="
          background: #000;
          display: flex;
          justify-content: center;
          height: 500px;
        "
      >
        <video :src="videoSrc" autoplay controls="controls"></video>
      </div>
    </el-dialog>
  </span>
</template>

<script>
export default {
  props: {
    /** 是否斜体 **/
    italic: {
      type: Boolean,
      default: false,
    },
    /** 是否加粗 **/
    strong: {
      type: Boolean,
      default: false,
    },
    /** 是否显示下划线 **/
    underline: {
      type: Boolean,
      default: false,
    },
    /** 文字内容 **/
    content: {
      type: String,
      default: "",
    },
    /** 左侧填充长度 **/
    leftFilling: {
      type: Number,
      default: 0,
    },
    /** 右侧填充长度 **/
    rightFilling: {
      type: Number,
      default: 0,
    },
    // 透明占位
    seat: {
      type: String,
      default: "",
    },
    // 哪里变色
    whereColor: {
      type: String,
      default: "all",
    },
    // 渲染颜色
    renderColor: {
      type: String,
      default: "#5c5c5c",
    },
  },
  data() {
    return {
      dialogVisible: false,
      videoSrc: "",
    };
  },
  computed: {
    /**
     * @name 渲染颜色计算
     * @return { string } 渲染颜色
     * @author liuguisheng
     * @version 2020-06-23 17:18:14 星期二
     */
    currentRenderColor() {
      let { whereColor, renderColor } = this;
      return whereColor == "all" || whereColor == "value"
        ? renderColor
        : "#5c5c5c";
    },
  },
  methods: {
    async onPlay(data) {
      // alert(renderCurrentModel)
      let mp4 = data.split(".");
      if (
        ["mp4", "ogg", "flv", "avi", "wmv", "rmvb", "mov"].includes(
          mp4[mp4.length - 1]
        )
      ) {
        this.videoSrc = data;
        this.dialogVisible = true;
      } else {
         let response = await fetch(data); // 内容转变成blob地址
        let blob = await response.blob();  // 创建隐藏的可下载链接
        let objectUrl = window.URL.createObjectURL(blob);
        // this.filepath = data;
        document.getElementById("file").setAttribute("href", objectUrl);
        document.getElementById("file").click();
      }
    },
  },
};
</script>
<style scoped>
.videoStr {
  cursor: pointer;
}
</style>




// WEBPACK FOOTER //
// src/components/base_package/RenderFormFileContent.vue